import { graphLabelText, graphValueText } from './';
export const graphNodeLabel = (theme, parameters) => {
  const common = {
    textColor: graphLabelText(theme, parameters).textColor,
    fontFamily: graphLabelText(theme, parameters).fontFamily,
    fontStyle: graphLabelText(theme, parameters).fontStyle
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          fontSize: graphLabelText(theme, parameters).fontSize,
          fontWeight: graphValueText(theme, parameters).fontWeight
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          fontSize: graphValueText(theme, parameters).fontSize,
          fontWeight: graphLabelText(theme, parameters).fontWeight
        };
      }
    default:
      {
        return {
          ...common,
          fontSize: graphLabelText(theme, parameters).fontSize,
          fontWeight: graphValueText(theme, parameters).fontWeight
        };
      }
  }
};
//# sourceMappingURL=graphNodeLabel.js.map